import React from 'react';
import { generateMetricsAttribute } from '@sm/metrics';
import { createURL } from '@sm/utils';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Button } from '~app/components/core/Button';

import useStyles from './useStyles';

export type ColorProp = 'sabaeus' | 'canvas';

type CopyTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';

export type Props = {
  copy: string;
  copyTag?: CopyTag;
  ctaText: string;
  color?: ColorProp;
  utSource: string;
  utSource2: string;
  hideCTAs?: boolean;
  route?: string;
};

const FortuneCallout = ({
  color = 'canvas',
  copy,
  copyTag = 'h3',
  ctaText,
  utSource,
  utSource2,
  hideCTAs = false,
  route = '/user/sign-up/',
}: Props): React.ReactElement => {
  const { container, button, copyElement, copyText } = useStyles({ color });
  const utSource3 = 'FortuneCallout';

  return (
    <Box data-testid="FortuneCallout" display="flex" flexAlign="center" flexDirection="column" className={container}>
      <Box className={copyElement}>
        <Typography
          component={copyTag}
          align="center"
          variant="sectionTitle"
          color={color === 'sabaeus' ? 'light' : 'primary'}
        >
          <span className={copyText}>{copy}</span>
        </Typography>
      </Box>
      {!hideCTAs && (
        <Box mt={5}>
          <Button
            className={button}
            size="lg"
            href={createURL(route, {
              ut_source: utSource,
              ut_source2: utSource2,
              ut_source3: utSource3,
              ut_ctatext: ctaText,
            })}
            data-sm-metric={generateMetricsAttribute({
              data: {
                actionType: `${utSource}_click_fortune_cta_to_sign_up`,
                actionFlow: { utSource },
              },
            })}
          >
            {ctaText}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default FortuneCallout;
